module.exports = __webpack_public_path__ + "b7cc666285deac2694ae83b914a7e1b8.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio3/08_3MCA-Upside-Down-Table.ogg
// module id = 793
// module chunks = 0